<div class="card mortgage-card">
  <div class="calc-header">
    <div class="calc-title-group">
      <span class="calc-eyebrow">Финансов симулатор</span>
      <h3>Калкулатор за ипотечен кредит в {{ cityName() }}</h3>
      <p class="calc-lead">
        Изчисли месечната вноска за жилище спрямо реалната медианна цена и официалната лихва в България.
      </p>
    </div>
  </div>

  <div class="calc-body">
    <!-- Controls section -->
    <div class="calc-controls">
      <!-- Area selector -->
      <div class="ctrl-group">
        <div class="ctrl-label-row">
          <label for="calc-area">Площ на жилището</label>
          <span class="ctrl-val">{{ areaM2() }} м² · {{ propertyPrice() | eur }}</span>
        </div>
        <div class="pill-group">
          @for (preset of areaPresets; track preset) {
            <button
              type="button"
              class="pill-btn"
              [class.active]="areaM2() === preset"
              (click)="setArea(preset)"
            >
              {{ preset }} м²
            </button>
          }
          <input
            id="calc-area"
            type="number"
            class="compact-input"
            min="20"
            max="500"
            step="5"
            [value]="areaM2()"
            (change)="updateArea($any($event.target).value)"
            aria-label="Персонализирана площ в кв.м"
          />
        </div>
      </div>

      <!-- Down payment selector -->
      <div class="ctrl-group">
        <div class="ctrl-label-row">
          <span>Самоучастие</span>
          <span class="ctrl-val">{{ estimate()?.downPaymentEur | eur }} ({{ downPaymentPct() }}%)</span>
        </div>
        <div class="pill-group">
          @for (preset of downPaymentPresets; track preset) {
            <button
              type="button"
              class="pill-btn"
              [class.active]="downPaymentPct() === preset"
              (click)="setDownPayment(preset)"
            >
              {{ preset }}%
            </button>
          }
        </div>
      </div>

      <!-- Term in years -->
      <div class="ctrl-group">
        <div class="ctrl-label-row">
          <span>Срок на кредита</span>
          <span class="ctrl-val">{{ years() }} години ({{ years() * 12 }} вноски)</span>
        </div>
        <div class="pill-group">
          @for (preset of yearsPresets; track preset) {
            <button
              type="button"
              class="pill-btn"
              [class.active]="years() === preset"
              (click)="setYears(preset)"
            >
              {{ preset }} г.
            </button>
          }
        </div>
      </div>

      <!-- Interest rate -->
      <div class="ctrl-group">
        <div class="ctrl-label-row">
          <label for="calc-rate">Годишна лихва</label>
          <span class="ctrl-val">{{ interestRate() }}%</span>
        </div>
        <div class="rate-input-row">
          <input
            id="calc-rate"
            type="number"
            class="rate-input"
            min="0.5"
            max="15"
            step="0.05"
            [value]="interestRate()"
            (input)="updateInterest($any($event.target).value)"
          />
          <span class="rate-hint">БНБ/ЕЦБ референтен процент: {{ defaultInterestRate() ?? 2.45 }}%</span>
        </div>
      </div>
    </div>

    <!-- Results display -->
    @if (estimate(); as est) {
      <div class="calc-results">
        <div class="monthly-hero">
          <span class="hero-label">Ориентировъчна месечна вноска</span>
          <div class="hero-val">{{ est.monthlyPaymentEur | eur }}<span class="per-mo">/месец</span></div>
          <div class="hero-sub">{{ est.monthlyPaymentBgn | bgn }}</div>
        </div>

        <div class="result-breakdown">
          <div class="breakdown-row">
            <span class="b-label">Размер на кредита</span>
            <span class="b-val">{{ est.loanAmountEur | eur }}</span>
          </div>
          <div class="breakdown-row">
            <span class="b-label">Самоучастие</span>
            <span class="b-val">{{ est.downPaymentEur | eur }}</span>
          </div>
          <div class="breakdown-row">
            <span class="b-label">Общо лихва за срока</span>
            <span class="b-val text-warn">{{ est.totalInterestEur | eur }}</span>
          </div>
          <div class="breakdown-row">
            <span class="b-label">Общо за изплащане</span>
            <span class="b-val strong">{{ est.totalPaymentEur | eur }}</span>
          </div>
          <div class="breakdown-row highlight-income">
            <span class="b-label" title="Препоръчителен минимален нетен семеен доход съгласно тавана на БНБ за максимално дългово бреме до 40% от дохода">
              Препоръчителен доход (DSTI ≤ 40%) ⓘ
            </span>
            <span class="b-val text-income">≥ {{ est.minNetIncomeEur | eur }}/мес.</span>
          </div>
        </div>
      </div>
    }
  </div>
</div>
